import { render, staticRenderFns } from "./EditAdminPwd.vue?vue&type=template&id=b262ddc4&scoped=true&"
import script from "./EditAdminPwd.vue?vue&type=script&lang=js&"
export * from "./EditAdminPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b262ddc4",
  null
  
)

export default component.exports